import request from '@/utils/request'

export type TabCode = 'BILL' | 'DETAILS' | 'AI'

export interface TabRedDotDTO {
  tabCode: TabCode
  hasRedDot: boolean
}

export interface AiUnreadCardTargetDTO {
  sessionId: string
  contentId: string
  cardId: string
}

export const getTabRedDots = () =>
  request.get<TabRedDotDTO[]>('/commonfacade/tab-red-dot/list', { skipDebugLog: true })

export const clearTabRedDot = (tabCode: TabCode) =>
  request.post<boolean>('/commonfacade/tab-red-dot/clear', { tabCode })

export const consumeAiUnreadCard = () =>
  request.post<AiUnreadCardTargetDTO | null>('/commonfacade/tab-red-dot/ai-unread-card/consume')

export const getUnshownAiUnreadCard = () =>
  request.get<AiUnreadCardTargetDTO | null>('/commonfacade/tab-red-dot/ai-unread-card/unshown')

export const acknowledgeAiUnreadCardShown = (contentId: string) =>
  request.post<boolean>('/commonfacade/tab-red-dot/ai-unread-card/shown', { contentId })
